export default [
  '_id',
  'type',
  'field',
  'displayType',
  'columnType',
  'width',
  'height',
  'x',
  'y',
  'format',
  'condition',
  'targetValue',
  'targetValueDisplayType',
  'customTrueTargetDisplayValue',
  'customFalseTargetDisplayValue',
  'invertBooleanCondition',
  'rowIndex',
  'column',
  'primaryDisplayOnly',
  'primaryMaxWidth',
  'primaryMaxHeight',
  'columnTitleFontSize',
  'columnTitleFontColor',
  'columnTitleFontStyle',
  'columnTitleFontWeight',
  'columnTitleTextAlign',
  'columnTitleTextTransform',
  'columnTitleTextDecoration',
  'columnTitleBackgroundColor',
  'columnTitlePadding',
  'columnTitleTextOverflow',
  'titleDisplay',
  'titleFontSize',
  'titleFontColor',
  'titleFontStyle',
  'titleFontWeight',
  'titleTextAlign',
  'titleTextTransform',
  'titleTextDecoration',
  'lineHeight',
  'fontSize',
  'fontColor',
  'fontStyle',
  'fontWeight',
  'textAlign',
  'textTransform',
  'textDecoration',
  'textOverflow',
  'padding',
  'margin',
  'borderColor',
  'borderRadius',
  'borderWidth',
  'backgroundColor',
  'zIndex',

  /**
   * Auto-shrink text properties. These live on the fieldPosition, alongside textOverflow and
   * fontSize, because they change how the field looks rather than what it asks. That also
   * makes them per-view, so desktop and mobile are configured independently.
   *
   * Without these entries separateFieldAndFieldPositionChangesForUpdate silently discards
   * them and the settings panel appears to work while saving nothing.
   */
  'autoShrink',
  'maxLines',
  'maxLength',

  /**
   * Auto-height text properties. Same reasoning as the auto-shrink block above: they change
   * how the field looks rather than what it asks, so they belong on the fieldPosition and are
   * configured per view.
   *
   * autoHeight is the switch. baseHeight is the height the field was drawn with when the switch
   * was ticked, and baseLineHeight the ruled line pitch a fillable PDF textarea had then. The
   * web SDK no longer reads baseHeight (an emptied field now fits one line rather than
   * returning to it) but still records both: the settings panel shows them, the auto-shrink
   * line cap on a fillable textarea is frozen at baseLineHeight, and other SDKs may read them.
   * Leaving them off this list would drop them silently from the changelog.
   */
  'autoHeight',
  'baseHeight',
  'baseLineHeight',

  //Special renamed properties to prevent conflict with field properties
  'fieldPositionSchema', //Actual is "schema" 
  'fieldPositionTableColumns', //Actual is "tableColumns"
];
